<template>
  <div class="registration">
    <advertising-figure :bannerSrc="bannerSrc" />
    <div class="inner-page-nav">
      <inner-page-nav />
    </div>
    <div class="inner-page-content">
      <public-title :title="title">
        <span class="sub">Registration Information-{{ this.localItem.status }}</span>
      </public-title>
      <div class="registration-form">
        <registration-form ref="localItem" :list="registrationList" :btns="registrationBtn" :form="form"
          :labelPosition="labelPosition" />

        <SignInQrCode></SignInQrCode>
      </div>
    </div>

    <!-- <div>
      <template v-for="(item, index) in cardList">
        <registration-card :options="item" :key="index" />
      </template>
    </div> -->
    <Payment></Payment>
  </div>
</template>

<script>
import AdvertisingFigure from "@components/advertising";
import InnerPageNav from "@components/tool-nav";
import publicTitle from "@components/title";
import RegistrationForm from "@components/form";
import singleSelect from "@components/singleSelect";
import multipleSelect from "@components/multipleSelect";
import SignInQrCode from "./components/SignInQrCode";
import Payment from "@/components/pay";
import RegistrationCard from "@views/registration/components/card.vue";
import { AttendIdentity } from "@/store/entity/attendidentity";
import { Confsite } from "@/store/entity/confsite";
import { User } from "@/store/entity/user";
import { Conference } from "@/store/entity/conference";
import merge from "lodash/merge";
import { Signup } from "@/store/entity/signup";
import radio from "@components/radio";
export default {
  name: "RegistrationPage",
  components: {
    AdvertisingFigure,
    InnerPageNav,
    publicTitle,
    RegistrationForm,
    RegistrationCard,
    SignInQrCode,
    Payment
  },
  mixins: [],
  data() {
    return {
      isInvoiced: false,
      invoiceUrl: "",
      attendidentityArr: [],
      confsiteOptions: [],
      requiredsites: [],
      requiredsiteids: [],
      bannerSrc: require("@assets/img/registration-banner.png"),
      title: "报名信息",
      labelPosition: "top",
      currentUser : new User(),
      currentConference : new Conference(),
      localItem: new Signup(),

      /* 是否显示提交按钮 */
      isShowSubmit: false,

      cardsInfos: [
        {
          title: "报名成功，缴费信息",
          subTitle: "Payment information",
          infoList: [
            { infoTit: "缴费状态", information: "未交费" },
            { infoTit: "缴费金额", information: "200" },
            { infoTit: "缴费时间", information: "2022-1-15" },
          ],
          btnText: "立即缴费",
          btnType: "primary",
        },
      ],
      //localItem: new Signup(),
      remark:""
    };
  },

  computed: {
    form: {
      get: function () {
          // 将store里查出来的报名记录放到localItem里，前提是localItem是初始空值
          // Object.keys(this.localItem).forEach((key) => {
          //   const value_of_local = this.localItem[key]
          //   const value_of_store = this.currentSignup[key]
          //   if ((!value_of_local || value_of_local.length==0)&& value_of_store) {
          //     this.localItem[key] = value_of_store
          //   }
          //   // if(key=="confsites" || key=="confsiteids"){
          //   //   this.localItem[key] = value_of_store
          //   // }
          // })
          this.localItem.confsiteids = this.localItem.confsites.map(x=> x.id)
          this.localItem.phone = this.currentUser.username
          // console.log(this.localItem)
          this.localItem.attendid_name = this.localItem.attendid.name
          let options = this.confsiteOptions.filter(item=>{
            if(this.localItem.confsiteids.includes(item.id)){
              return item
            }
          })
          this.localItem.optinnames = options.map(x=>x.name).join(",")
          return this.localItem
        },
        set(form) {
          this.localItem = form
          this.localItem.confsites = this.confsiteOptions.filter(x=> this.localItem.confsiteids.includes(x.id))
          this.localItem.phone = this.$store.state.user.currentUser.username
        },
    },

    registrationList() {
      let readonlyFlag = this.localItem.status == "已完成" || this.localItem.status == "审核中";

      let list = [
        {
          label: "姓名",
          prop: "name",
          render: "ElInput",
          attrs: {
            placeholder: "请输入姓名",
            readonly: readonlyFlag,
          },
          position: {
            span: 12,
          },
        },

        {
          label: "单位",
          prop: "company",
          render: "ElInput",
          attrs: {
            placeholder: "请输入单位名称",
            readonly: readonlyFlag,
          },
          position: {
            span: 12,
          },
        },

        {
          label: "电话",
          prop: "phone",
          render: "ElInput",
          attrs: {
            placeholder: "请输入电话",
            readonly: readonlyFlag,
            readonly: true,
          },
          position: {
            span: 12,
          },
        },
        {
          label: "电子邮箱",
          prop: "email",
          render: "ElInput",
          attrs: {
            placeholder: "请输入邮箱地址",
            readonly: readonlyFlag,
          },
          position: {
            span: 12,
          },
        },
        {
          label: "职务",
          prop: "job",
          render: "ElInput",
          attrs: {
            placeholder: "请输入职务",
            readonly: readonlyFlag,
          },
          position: {
            span: 12,
          },
        }];
        
        if(this.attendidentityArr.map(x=>x.id).includes(this.localItem.attendid.id)){
          list.push(
            {
              label: "参会身份",
              prop: "attendid_id",
              render: singleSelect,
              attrs: {
                options: this.attendidentityArr,
                labelField: "identity",
                valueField: "id",
                disabled: readonlyFlag,
              },
              position: {
                span: 12,
              },
            })
        }else{
          list.push(
            {
              label: "参会身份",
              prop: "attendid_name",
              render: "ElInput",
              attrs: {
                readonly: true,
              },
              position: {
                span: 12,
              },
            })
        }
        if(this.localItem.status == "已完成" || this.localItem.status == "审核中"){
          list.push(
            {
              label: "会场",
              prop: "optinnames",
              render: "ElInput",
              attrs: {
                readonly: true,
              },
              position: {
                span: 12,
              },
            })
        }else{

          list.push(
            {
              label: "会场"+this.remark,
              prop: "confsiteids",
              render: multipleSelect,
              attrs: {
                options: this.confsiteOptions,
                labelField: "name",
                valueField: "id",
                disabledField: "disabled",
                clearable:false,//必须为false，不然会影响功能
              },
              listeners: {
                confsitechange: this.confsitechange,
                removeTag:this.removeTag
              },
              position: {
                span: 12,
              },
            },)
        }
      let attendValue = this.localItem.attendid_id;
      let attendCode = this.getAttendCode(attendValue);
      if (attendCode == "A3") {
        //学生
        //学生
        list.push({
          label: "学生证号",
          prop: "stu_code",
          render: "ElInput",
          disabled: false,
          attrs: { placeholder: "请输入学生证号", readonly: readonlyFlag },
          position: { span: 12 },
        });
      } else if (attendCode == "A4") {
        //论文第一作者
        //论文第一作者
        list.push({
          label: "论文编号",
          prop: "paper_code",
          render: "ElInput",
          disabled: false,
          attrs: { placeholder: "请输入论文编号", readonly: readonlyFlag },
          position: { span: 12 },
        });
      } else if (attendCode == "A5") {
        //工程会员
        //工程会员
        list.push({
          label: "工程会员编号",
          prop: "vip_code",
          render: "ElInput",
          disabled: false,
          attrs: { placeholder: "请输入工程会员编号", readonly: readonlyFlag },
          position: { span: 12 },
        });
      } else if (attendCode == "A6") {
        //其他
        //其他
        list.push({
          label: "备注",
          prop: "note",
          render: "ElInput",
          disabled: false,
          attrs: { placeholder: "请输入备注信息", readonly: readonlyFlag },
          position: { span: 12 },
        });
      }
      let invoice_pre_list = [
        {
          label: "发票抬头类型",
          prop: "title_type",
          render: radio,
          attrs: {
            options:["单位票据","个人票据"],
          },
          position: {
            span: 6,
          },
          listeners: {
              typechange: this.typechange
          },
        },
        {
          label: "发票类型",
          prop: "fplx",
          render: radio,
          attrs: {
            options:["数电普票","数电专票"],
          },
          position: {
            span: 6,
          },
        },
        {
          label: "发票购买方名称",
          prop: "ghdwmc",
          render: "ElInput",
          attrs: {
            placeholder: "请输入购买方名称",
          },
          position: {
            span: 12,
          },
          listeners : {
          }
        },
        // {
        //   label: "发票购买方手机号",
        //   prop: "ghsjh",
        //   render: "ElInput",
        //   attrs: {
        //     placeholder: "请输入购买方手机号",
        //   },
        //   position: {
        //     span: 12,
        //   },
        // },
        {
          label: "发票购买方税号/身份证号：单位票据填写税号，个人票据填写身份证号",
          prop: "ghnsrsbh",
          render: "ElInput",
          attrs: {
            placeholder: "请输入发票购买方税号/身份证号",
          },
          position: {
            span: 12,
          },
        },
        {
          label: "销售方银行账号是否显示",
          prop: "sfzsxsfyhzh",
          render: radio,
          attrs: {
            options: ["否", "是"],
          },
          position: {
            span: 6,
          },
          listeners: {},
        },
        {
          label: "销售方地址电话是否显示",
          prop: "sfzsxsfdzdh",
          render: radio,
          attrs: {
            options: ["否", "是"],
          },
          position: {
            span: 6,
          },
        },
        {
          label: "购买方银行账号是否显示",
          prop: "sfzsgmfyhzh",
          render: radio,
          attrs: {
            options: ["否", "是"],
          },
          position: {
            span: 6,
          },
          listeners: {},
        },
        {
          label: "购买方地址电话是否显示",
          prop: "sfzsgmfdzdh",
          render: radio,
          attrs: {
            options: ["否", "是"],
          },
          position: {
            span: 6,
          },
        },
        {
          label: "发票购买方地址",
          prop: "ghdz",
          render: "ElInput",
          attrs: {
            placeholder: "请输入购买方地址",
          },
          position: {
            span: 12,
          },
        },
        {
          label: "发票购买方电话",
          prop: "ghdh",
          render: "ElInput",
          attrs: {
            placeholder: "请输入购买方电话",
          },
          position: {
            span: 12,
          },
        },
        {
          label: "发票购买方银行名称",
          prop: "ghyh",
          render: "ElInput",
          attrs: {
            placeholder: "请输入购买方银行名称",
          },
          position: {
            span: 12,
          },
        },
        {
          label: "发票购买方银行账号",
          prop: "ghzh",
          render: "ElInput",
          attrs: {
            placeholder: "请输入购买方银行账号",
          },
          position: {
            span: 12,
          },
        },
      ];
      list.push(...invoice_pre_list);
      return list;
    },

    registrationBtn() {
      return [
        {
          label: "修改",
          attrs: {
            type: "primary",
            class: "editBtn",
            style:
              this.localItem.status != "已完成" && this.localItem.status !== "审核中"
                ? "display: inline-block"
                : "display: none",
          },
          listeners: {
            click: this.handleEdit,
          },
        },
        {
          label: "提交",
          attrs: {
            type: "success",
            class: "submitBtn",
            style: this.isShowSubmit && (this.localItem.status != "已完成" && this.localItem.status !== "审核中")
              ? "display: inline-block"
              : "display: none",
          },
          listeners: {
            click: this.handleFormSubmit,
          },
        },
      ];
    },

    cardList: {
      get() {
        return this.cardsInfos;
      },
      set(newValue) {
        this.cardsInfos.push(newValue);
      },
    },
  },
  watch: {
    
  },
  async created() {
    //如果管理员增加了会场的必须参加的场次，需要追加到会场选择框中，用到了此方法setRequiredSites。涉及到watch和created执行顺序的影响，因此去掉了mixin
    await this.$store.dispatch('conference/getCurrentConference').then((res) => {this.currentConference =  res})
    await this.$store.dispatch("user/getUserInfo").then((res) => {this.currentUser = res})
    await this.$store.dispatch('user/getSignupInfo',{username:this.currentUser.username,id:this.currentConference.id}).then((res) => {this.localItem = res});
    this.getAttendIdentityList();
    await this.getConfSiteOptions();
    if(this.localItem.status != "已完成" && this.localItem.status !== "审核中"){
      this.setRequiredSites();
    }
    this.getConsiteRemark(this.confsiteOptions);
  },
  methods: {
    typechange(val){
      if(val=="单位票据"){
      }
      if(val=="个人票据"){
      }
      //清除表单中所有输入字段的校验状态
      //this.$refs.localItem.clearValidate();
    },
    getOptionByid(val){
      let options = this.confsiteOptions.filter(item=>{
        if(item.id==val){
          return item
        }
      })
      return options[0]
    },
    removeTag(val){
      if(this.requiredsiteids.includes(val)){
        let defaultIndex = this.requiredsiteids.indexOf(val) // 获取默认值在数组中的下标
        this.localItem.confsiteids.splice(defaultIndex, 0, val) // 将要删除的值插入到默认值对应的下标位置
        this.localItem.confsites.splice(defaultIndex, 0, this.getOptionByid(val)) // 将要删除的值插入到默认值对应的下标位置
      }
    },
    setRequiredSites(){
      this.requiredsites.forEach(item=>{
          if(this.localItem.confsiteids.indexOf(item.id)<0){
            this.localItem.confsiteids.push(item.id);
            this.localItem.confsites.push(item);
          }
      })
    },
    getConsiteRemark(confsiteOptions) {
      let requireditemname="";
      confsiteOptions.forEach(item=>{
        if(item.isrequired){
          requireditemname+=item.name+"、"
        }
      })
      requireditemname = requireditemname.substring(0,requireditemname.length-1);
      this.remark = "：同一时间举行的多个分论坛只能选择其中之一；"
      if(requireditemname.length>0){
        this.remark += requireditemname+"为必选项"
      }
    },
    arrayGroup(arr) {
      var str = {};
      var newArr = [];
      for (var i = 0; i < arr.length; i++) {
        var obj = arr[i];
        if (!str[obj.flag]) {
          newArr.push({
            flag: obj.flag,
            children: [obj]
          })
          str[obj.flag] = obj;
        } else {
          for (var j = 0; j < newArr.length; j++) {
            var newobj = newArr[j];
            if (newobj.flag === obj.flag) {
              newobj.children.push(obj);
              break;
            }
          }
        }
      }
      return newArr;
    },
    confsitechange(val) {
      //选中的数据对象
      let selectedsites = [];
      for (const selectedval of val) {
        for (const site of this.confsiteOptions) {
          if (selectedval == site.id) {
            selectedsites.push(site);
          }
        }
      }
      let groupedsites = this.arrayGroup(selectedsites);
      
      this.localItem.confsiteids=[];
      this.localItem.confsites=[];
      for(const groupedsite of groupedsites){
        if(groupedsite.children.length==1){
          this.localItem.confsiteids.push(groupedsite.children[0].id)
          this.localItem.confsites.push(groupedsite.children[0])
        }else{
          this.localItem.confsiteids.push(groupedsite.children[groupedsite.children.length-1].id)
          this.localItem.confsites.push(groupedsite.children[groupedsite.children.length-1])
        }
      }
    },
    getAttendCode(attendId) {
      for (const item of this.attendidentityArr) {
        // console.log("item=" + item)
        if (item.id == attendId) {
          return item.code;
        }
      }
    },
    getSignup() {
      let id = 0;
      if (this.currentSignup.id) {
        id = this.currentSignup.id
      }
      Signup.getSignupList({
        per_page: -1,
        page: -1,
        id: id,
      }).then((data) => {
        data.signup_list.forEach((x) => {
          //this.localItem=x;
          merge(this.localItem, x);
          for(const item of this.localItem.confsites){
            this.localItem.confsiteids.push(item.id);
          }
          // console.log(this.localItem)
          // console.log(this.localItem)
        });
        //this.rules["name"][0]["required"] = false;
      });
    },
    getAttendIdentityList() {
      let ids = {};
      ids = AttendIdentity.getAttendIdentityList({
        per_page: -1,
        page: -1,
        order_by:"order"
      }).then((data) => {
        this.attendidentityArr = []
        data.attendidentity_list.forEach((x) => {
          if (x.code != "A7") {
            this.attendidentityArr.push({
              id: x.id,
              identity: x.name,
              code: x.code,
            });
          }
        });
      });
    },
    async getConfSiteOptions() {
      if(this.currentConference.id && this.currentConference.id>0){
        await Confsite.getList({
          conference_id:this.currentConference.id,
          per_page: -1,
          page: -1,
        }).then((data) => {
          this.confsiteOptions = data.result.sort((a,b)=>a.order<b.order?-1:1)
          this.confsiteOptions.forEach((item)=>{
            if(item.fulled=="是"){
              item.name +="(已满)"; 
              item.disabled = true 
            }
            if(item.isrequired){
              item.disabled = true
            }
          })
          //过滤出是必选项的
          this.requiredsites = this.confsiteOptions.filter(item => {
            if(item.isrequired == true){
              this.requiredsiteids.push(item.id);
              return item
            }
          })
        });
      }
    },
    handleFormSubmit() {
      let attendValue = this.localItem.attendid_id;
      let attendCode = this.getAttendCode(attendValue);

      if (
        !this.localItem.name ||
        this.localItem.name.length > 15
      ) {
        this.$alert("输入姓名不能为空且不能多于15个字");
      } else if (
        !this.localItem.company ||
        this.localItem.company.length > 30
      ) {
        this.$alert("输入单位不能为空且不能多于30个字");
      } else if (
        !this.localItem.job ||
        this.localItem.job.length > 15
      ) {
        this.$alert("输入职务不能为空且不能多于15个字");
      } else if (!this.localItem.phone) {
        this.$alert("请输入电话");
      } else if (!this.checkPhone(this.localItem.phone)) {
        this.$alert("请正确输入手机号码");
      } else if (!this.localItem.email) {
        this.$alert("请输入邮箱");
      } else if (!this.checkEmail(this.localItem.email)) {
        this.$alert("请正确输入邮箱");
      } else if (!this.localItem.attendid_id) {
        this.$alert("请选择参会身份");
      } else if (
        attendCode == "A3" &&
        (!this.localItem.stu_code ||
          this.localItem.stu_code.length > 20)
      ) {
        this.$alert("学生证号不能为空且不能多于20个字");
      } else if (
        attendCode == "A4" &&
        (!this.localItem.paper_code ||
          this.localItem.paper_code.length > 20)
      ) {
        this.$alert("论文编号不能为空且不能多于20个字");
      } else if (
        attendCode == "A5" &&
        (!this.localItem.vip_code ||
          this.localItem.vip_code.length > 20)
      ) {
        this.$alert("工程会员编号不能为空且不能多于20个字");
      } else if (attendCode=="A6"&&(!this.localItem.pub_trans_name || this.localItem.pub_trans_name.length > 15)) {
        this.$message({message: "当参会身份为其他(对公转账)时对公转账人姓名不能为空且不能多于15个字",type: 'warning'});
      } else if (attendCode=="A6"&&(!this.localItem.pub_trans_comp || this.localItem.pub_trans_comp.length > 100)) {
        this.$message({message: "当参会身份为其他(对公转账)时对公转账人单位不能为空且不能多于100个字",type: 'warning'});
      } else if (attendCode=="A6"&&(!this.localItem.pub_trans_phone)) {
        this.$message({message: "当参会身份为其他(对公转账)时对公转账人手机号码不能为空",type: 'warning'});
      } else if (attendCode=="A6"&&!this.checkPhone(this.localItem.pub_trans_phone)) {
        this.$message({message: "请正确输入对公转账人手机号码",type: 'warning'});
      } else if (!this.localItem.confsites) {
        this.$alert("请选择会场");
      }  else if (!this.localItem.title_type) {
        this.$message({
          message: "发票抬头类型为必选项",type: 'warning'
        });
      }
      else if (!this.localItem.fplx) {
        this.$message({
          message: "发票类型为必选项",type: 'warning'
        });
      }
      else if (!this.localItem.ghdwmc) {
        this.$message({
          message: "发票购买方名称为必填项",type: 'warning'
        });
      } else if (!this.localItem.ghdzyx) {
        this.$message({
          message: "购买方电子邮箱为必填项",type: 'warning'
        });
      } else if (
        !/^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/.test(
          this.localItem.ghdzyx
        )
      ) {
        this.$message({
          message: "请输入正确电子邮箱",type: 'warning'
        });
      }else if(this.localItem.title_type=="单位票据" && !this.localItem.ghnsrsbh){
        this.$message({
          message: "发票抬头类型为单位票据时，购买方税号为必填项",type: 'warning'
        });
      } else if (this.localItem.title_type=="单位票据" &&
        !/^[0-9A-HJ-NPQRTUWXY]{18}$/.test(
          this.localItem.ghnsrsbh
        ) && this.localItem.ghnsrsbh !== "88888888888888888888" && this.localItem.ghnsrsbh !== "610111768824461"
      ) {
        this.$message({
          message: "请输入正确购买方税号",type: 'warning'
        });
      } else if (this.localItem.title_type=="个人票据" && this.localItem.ghnsrsbh.trim().length>0 && !this.isValidIdCard(this.localItem.ghnsrsbh)
      ) {
        this.$message({
          message: "请输入正确购买方身份证号",type: 'warning'
        });
      } 
      else {
        const item = new Signup()
        merge(item, this.localItem);
        item.conference_id = this.currentConference.id;
        item.user_id = this.currentUser.id;
        item.status = "已完成";
        let attendCode = this.getAttendCode(item.attendid_id);
        if (attendCode == "A6" || attendCode == "A3" || attendCode == "A5") {
          item.status = "审核中";
        }
        //this.localItem.paid_status="未缴费";
        // handle: () => {
        item.createOrUpdateSignup().then((res) => {
          // 报完名后可能状态发生改变，所以重新获取报名状态
          this.$store.dispatch("user/resetFetchSignupInfo")
          merge(this.localItem, res.data.item);
          // this.localItem = item;
          //报名成功后跳转到缴费页面
          // this.$router.push("registration");

        });
        // this.localItem.addConfSites(this.localItem.id,this.localItem.confsites).then((item)=>{
        //   merge(this.localItem, item);
        // });
        //}
      }
    },
    isValidIdCard(idCard) {  
        // 正则表达式，匹配 18 位身份证号  
        // 15 或 18 位，18位时最后一位可以为 X  
        const idCardReg = /(^\d{15}$)|(^\d{17}([0-9]|X)$)/;  
          
        // 校验身份证长度  
        if (idCard.length === 15 || idCard.length === 18) {  
            // 使用正则表达式校验  
            if (idCardReg.test(idCard)) {  
                // 校验通过，进行进一步校验（可选，如校验生日、地区码等）  
                // 这里只是简单的校验，没有进行复杂的逻辑校验  
                return true;  
            }  
        }  
          
        // 如果不满足以上条件，则返回 false  
        return false;  
    } ,

    handleEdit() {
      this.isShowSubmit = true;
    },

    checkEmail(email) {
      var reg =
        /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/;
      if (!reg.test(email)) {
        return false;
      }
      return true;
    },
    checkPhone(phone) {
      var reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
      if (!reg.test(phone)) {
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@assets/scss/innerpagenav.scss";

::v-deep .el-col {
  padding: 0 15px;

  .submitBtn,
  .editBtn {
    width: 120px;
    margin: 30px 15px 0 0;
  }
}

::v-deep .el-select {
  width: 100%;
}

.inner-page-nav {
  position: relative;
  width: 1200px;
  height: 60px;
  padding: 0 15px;
  margin: 0 auto;
}

.inner-page-content {
  margin: 60px 0;
}

.registration-form {
  @include flex-start;
  align-items: flex-end;
  width: 1200px;
  padding: 0 15px;
  margin: 60px auto 0;

  .el-form {
    flex: 70%;
    margin-right: 60px;
  }

  // .qr-code-wrap {
  //   text-align: center;

  //   .download {
  //     margin-top: 45px;
  //   }
  // }
}
</style>